/**
 * Auth Tokens
 * 	Handles everything necessary for keeping track of the Auth Tokens
 */
export function clearToken(){ return sessionStorage.removeItem("csrf"); }
export function setToken(value){ return sessionStorage.setItem("csrf", value); }
export function getToken(){ return sessionStorage.getItem("csrf"); }
